/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var exportInGlobalDbg = require("../util/debug").exportInGlobalDbg;

var ClientBroadcastManager = require("./clientBroadcastManager");
var SignalRConnection = require("./SignalRConnection");

var clientBroadcastManager = new ClientBroadcastManager(SignalRConnection);

module.exports = exportInGlobalDbg("clientBroadcastManager", clientBroadcastManager);




//////////////////
// WEBPACK FOOTER
// ./~/pli/clientbroadcastmanager/index.js
// module id = 477
// module chunks = 49